import { getBoard, getAllBoards, boardIds } from '@skyrover/board-definitions';
import type { BoardDefinition } from '@skyrover/shared/types';
import { create } from 'zustand';

interface BoardState {
  boardId: string;
  board: BoardDefinition;
  setBoardId: (boardId: string) => void;
  allBoards: BoardDefinition[];
}

const defaultBoardId = 'arduino-uno';
const defaultBoard = getBoard(defaultBoardId)!;

export const useBoardStore = create<BoardState>((set) => ({
  boardId: defaultBoardId,
  board: defaultBoard,
  allBoards: getAllBoards(),
  setBoardId: (boardId: string) => {
    const board = getBoard(boardId);
    if (!board) {
      return;
    }
    set({ boardId, board });
  },
}));

export { boardIds };
